import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { bindActionCreators } from "redux";
import * as DeliveryDriversActions from "../../../store/actions/DeliveryDrivers";
import {
  DriverBasicDetailsContainer,
  FieldHolder,
} from "../../../constants/assets/DriverDetailsContainers";
import LogsListFields from "../../../constants/DeliveryDrivers/LogsListFields.json";
import BlankState from "../../Common/BlankState";
import variables from "../../../constants/assets/variables";
import moment from "moment";
import {
  FieldsContainer,
  FieldsSection,
} from "../../../constants/assets/containers";
import {
  getPath,
  isValNull,
  setNestedKeyValue,
  getObjectsDifference,
} from "../../../utils";
import AssignmentStatusFields from "../../../constants/DeliveryDrivers/AssignmentStatusFields.json";
import Button from "sushiweb/Button/Button";
import Input from "sushiweb/InputTypes/Input";
import PaginatedReactDropdown from "../../Common/PaginatedReactDropdown";
import ErrorModal from "../../Common/ErrorModal";

const getDropdownVal = (value, options, field) => {
  if (!field.labelKey || !field.valueKey) {
    return value;
  }
  const selectedOption = options.find((item) => item[field.valueKey] === value);
  return field && selectedOption && selectedOption[field.labelKey];
};

const AssignmentStatus = ({
  editState,
  driverAssignmentStatus,
  getDriverAssignmentStatus,
  saveState,
  updateDriverAssignmentStatus,
  setSaveState,
  handleAfterSave,
}) => {
  const { id } = useParams();
  const [initialState, setInitialState] = useState({});
  const [errors, setErrors] = useState([]);

  useEffect(() => {
    if (getPath(driverAssignmentStatus, "driver_id", 0) !== id) {
      getDriverAssignmentStatus(id);
    }
  }, [id]);

  useEffect(() => {
    rollBackInitialState();
  }, [driverAssignmentStatus]);

  const handleChange = (key, val, isNumber, isDateField) => {
    const values = { ...initialState };
    let finalVal = val;
    setNestedKeyValue(values, key, finalVal);
    setInitialState(values);
  };
  const getValue = (field) => {
    return getPath(initialState, field.key, "") + "";
  };

  const rollBackInitialState = () => {
    const activeDetailsCopy = JSON.parse(
      JSON.stringify(driverAssignmentStatus)
    );
    setInitialState(activeDetailsCopy);
  };

  const handleErrorModalSubmit = () => {
    setErrors([]);
  };

  //to handle click on save button
  useEffect(() => {
    saveState && handleSubmit();
  }, [saveState]);

  const handleSubmit = () => {
    const payload = getObjectsDifference(driverAssignmentStatus, initialState);
    if (Object.keys(payload).length > 0) {
      updateDriverAssignmentStatus(id, payload).then((res) => {
        if (res) {
          setSaveState(false);
          handleAfterSave();
          getDriverAssignmentStatus(id);
        }
      });
    } else {
      const err = [];
      err.push("Error! You didn't make any change");
      setErrors(err);
    }
  };

  const getField = (type, field) => {
    switch (type) {
      case "text":
        return (
          <Input
            borderColor={variables.primaryColor}
            id="sushi-input"
            data-testid={field.id}
            fullWidth={true}
            disabled={editState && field.disabled}
            onChange={(e) => handleChange(field.key, e, field.isNumber)}
            value={field.value || getValue(field)}
          />
        );
      case "dropdown":
        return (
          <PaginatedReactDropdown
            options={field.options}
            disabled={field.disabled}
            labelKey={field.labelKey}
            valueKey={field.valueKey}
            value={getDropdownVal(
              getPath(initialState, field.key, ""),
              field.options,
              field
            )}
            handleChange={handleChange}
            placeholder=""
            keyToChange={field.key}
            showCross={true}
            id={`driverFinancialDetailsDropdown${field.labelKey}`}
          />
        );
    }
  };

  return (
    <AssignmentStatusContainer
      editState={editState}
      className={!editState && "no-edit"}
    >
      {AssignmentStatusFields.sections.map((section, index) => {
        return (
          <FieldsSection key={index}>
            {section.name && <p>{section.name}</p>}
            <FieldsContainer className="fields-container">
              {section.fields.map((field, fieldIdx) => {
                return (
                  <React.Fragment>
                    <FieldHolder noBorder={field.noBorder} justify="flex-start">
                      {field.placeholder && (
                        <span>
                          {field.placeholder}
                          {field.isMandatory && <sup>*</sup>}
                        </span>
                      )}
                      {getField(field.type, field)}
                    </FieldHolder>
                    {field.note && (
                      <p className="mb-10 note-field">{field.note}</p>
                    )}
                  </React.Fragment>
                );
              })}
            </FieldsContainer>
          </FieldsSection>
        );
      })}
      {errors.length > 0 && (
        <ErrorModal
          handleSubmit={handleErrorModalSubmit}
          heading="Error while saving"
          errors={errors}
        />
      )}
    </AssignmentStatusContainer>
  );
};

const AssignmentStatusContainer = styled(DriverBasicDetailsContainer)``;

const FieldHeading = styled(FieldHolder)`
  span {
    color: ${variables.black};
    word-break: break-all;
  }
`;

function mapStateToProps(state) {
  const { DeliveryDrivers } = state;
  return {
    driverAssignmentStatus: DeliveryDrivers.driverAssignmentStatus,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getDriverAssignmentStatus: bindActionCreators(
      DeliveryDriversActions.getDriverAssignmentStatus,
      dispatch
    ),
    updateDriverAssignmentStatus: bindActionCreators(
      DeliveryDriversActions.updateDriverAssignmentStatus,
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AssignmentStatus);
